// Brand payoff — single source of truth (multilingua IT/EN/ES/PT)
// Used in: Navbar, Footer, Helmet meta (per page), Schema.org slogan,
// form auto-replies, future PDFs and email signatures.
//
// IT (canonical):  "Le radici italiane diventano finanziamenti per i Comuni."
//
// The Italian word "Comuni" is intentionally preserved across all languages
// to reinforce brand authenticity and the Italian-roots positioning.

export const PAYOFF = {
  it: {
    short: 'Le radici italiane diventano finanziamenti per i Comuni.',
    long: 'Italian Roots Discovery — Le radici italiane diventano finanziamenti per i Comuni.',
  },
  en: {
    short: 'Italian roots, turned into funding for Italian Comuni.',
    long: 'Italian Roots Discovery — Italian roots, turned into funding for Italian Comuni.',
  },
  es: {
    short: 'Las raíces italianas se transforman en financiación para los Municipios.',
    long: 'Italian Roots Discovery — Las raíces italianas se transforman en financiación para los Municipios.',
  },
  pt: {
    short: 'As raízes italianas transformam-se em financiamentos para os Municípios.',
    long: 'Italian Roots Discovery — As raízes italianas transformam-se em financiamentos para os Municípios.',
  },
};

export const getPayoff = (language) => PAYOFF[language] || PAYOFF.it;
